
document.addEventListener('DOMContentLoaded', function(event) {

    const ajaxUrl = window.location.origin + '/wp-admin/admin-ajax.php';

    /**
	 * Load featured video on button click
	 */
	const openVideoLinks = document.querySelectorAll('.open-featured-video');
	openVideoLinks.forEach( (link, index) => {
		link.addEventListener('click', e => {

            e.preventDefault();

            const videoId = link.getAttribute('data-video-id');
            const youtubeUrl = link.getAttribute('data-youtube-url');
            if ( (typeof videoId === 'undefined' || videoId == '') && (typeof youtubeUrl === 'undefined' || youtubeUrl == '') ) return;
            
            let fetchUrl = ajaxUrl + '?action=get_featured_video_embed';
            if ( typeof youtubeUrl !== 'undefined' && youtubeUrl != '' ) {
                fetchUrl += '&youtubeUrl=' + youtubeUrl;
            } else if ( typeof videoId !== 'undefined' && videoId != '' ) {
                fetchUrl += '&videoId=' + videoId;
            }
            
			fetch( fetchUrl )
                .then(response => response.json())
                .then(video => {

                    const featured_video_block = link.closest('.wp-block-crown-blocks-featured-video');
                    const play_video_links = featured_video_block.querySelectorAll('.open-featured-video');
                    play_video_links.forEach( (pvl, i) => pvl.remove() );
                    
                    let featured_video = featured_video_block.querySelector('.featured-video__preview-image');
                    featured_video.innerHTML += video;
                    
                });
			
		}, true);
	});
    
});
